import router from "@/router";
import store from "@/store";
export default class OpenChatAction {
    contactId;
    messageId;
    constructor(contactId, messageId) {
        this.contactId = contactId;
        this.messageId = messageId;
    }
    async run() {
        const data = {
            action: 'OpenChat',
            contactId: this.contactId,
            messageId: this.messageId
        };
        store.commit('setPushNotificationAction', data);
        if (router.currentRoute.value.name !== 'CampusApp') {
            await router.push({ name: 'CampusApp', query: data });
            return;
        }
        const webviewIframeEl = document.getElementById('webviewIframe');
        const contentWindow = webviewIframeEl?.contentWindow;
        if (contentWindow !== null) {
            contentWindow.postMessage(data, '*');
        }
    }
}
